import { Grid, TextField } from '@mui/material'
import React, { useContext } from 'react'
import styles from './../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext'
import textStyles from './../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import IconsColor from '../../../../utility/iconsColor'
import CloseIcon from '@mui/icons-material/Close'
import { isCurrentViewVersionPublished } from '../../utilityFunctions'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext'
import ChatbotException from './chatbotException'

const CustomRepliesComponent = (props: any) => {
    const { currentActiveNodeConfig, onChangeCurrentActiveNodeConfig, updateNodeStepActions, nodes, onBlurOfFallBackOfBtnVar } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { headingName, actionData, stepAction } = props;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    return (
        <Grid container direction={"column"} gap={"6px"} mt={"12px"}>
            {/* <Grid item className={styles.stepComponentsHeadingStyle}>
                {headingName}
            </Grid> */}

            <Grid item className={styles.optionsContainer}>
                <Grid container direction={"column"} gap={"14px"}>
                    <Grid item>
                        <Grid container direction={"column"} gap={1}>
                            {actionData && actionData.action_text_message_variant_data.map((action: any) => {

                                return <Grid item sx={{ display: "flex", flexWrap: "nowrap", alignItems: "center" }} gap={1}>
                                    <TextField
                                        placeholder={"Enter a message text"}
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        className={styles.enterWordTextField}
                                        value={action.action_text_message_value}
                                        multiline={true}
                                        onChange={(event) => {
                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                {
                                                    ...action,
                                                    action_text_message_value: event.target.value
                                                },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }
                                            );
                                            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                {
                                                    ...action,
                                                    action_text_message_value: event.target.value
                                                },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }
                                            );
                                        }}
                                    />
                                    {actionData && actionData?.action_text_message_variant_data?.length > 1 &&
                                        <CloseIcon
                                            sx={{ display: "flex", height: "22px", width: "22px", cursor: isCurrentViewVersionPublished(currentActiveStaticWorkflow) ? "not-allowed" : "pointer", opacity: isCurrentViewVersionPublished(currentActiveStaticWorkflow) ? "0.5" : "1" }}
                                            onClick={() => {
                                                if (!isCurrentViewVersionPublished(currentActiveStaticWorkflow)) {
                                                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...action, flag_remove_variant: true },
                                                        {
                                                            updateType: "editExistingStepAction",
                                                        }
                                                    );
                                                    onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...action, flag_remove_variant: true },
                                                        {
                                                            updateType: "editExistingStepAction",
                                                        }
                                                    )
                                                }

                                            }}
                                        />
                                    }
                                </Grid>
                            })
                            }

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {!isCurrentViewVersionPublished(currentActiveStaticWorkflow) && actionData && actionData.action_text_message_variant_data?.length < 3 &&
                <Grid item
                    className={textStyles.fieldHeadingStyle}
                    sx={{ color: "blue !important", textAlign: "end" }}

                >
                    <Grid container alignItems={"center"} gap={"6px"} justifyContent={"end"}>
                        <Grid item sx={{ display: "flex", cursor: "pointer", }} onClick={() => {
                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { flag_variant: true },
                                {
                                    updateType: "editExistingStepAction"
                                }
                            )
                        }}>
                            <IconsColor fillColor="blue" iconName="plus" height="15" width="15" />
                        </Grid>
                        <Grid item sx={{ cursor: "pointer" }} onClick={() => {
                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { flag_variant: true },
                                {
                                    updateType: "editExistingStepAction"
                                }
                            )
                        }}>
                            Add Variant
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default CustomRepliesComponent
